import { ButtonHeart, ButtonHeartProps } from '../../../atoms/ButtonHeart/ButtonHeart';
import { FanLetterItemButtonHeartEvent } from '../event/FanLetterItemEvent';
import { goLogin } from '../../../../../shared/util/goLogin';

export class FanLetterItemButtonHeartView extends ButtonHeart {
  private is_login: boolean;
  private fan_letter_id: number;
  private store_id: number;

  constructor(data: ButtonHeartProps & { is_login: boolean; fan_letter_id: number; store_id: number }) {
    super(data);
    this.is_login = data.is_login;
    this.fan_letter_id = data.fan_letter_id;
    this.store_id = data.store_id;
  }

  public getIsActive() {
    return this.data.is_active || false;
  }

  public toggleIsActive() {
    this.data.is_active = !this.data.is_active;
    if (this.data.is_active) {
      this._upCount();
    } else {
      this._downCount();
    }
    this.applyElement();
  }

  private _upCount() {
    ++this.data.count;
  }

  private _downCount() {
    --this.data.count;
  }

  protected override onRender() {
    this.addEventListener('click', () => {
      if (this.is_login) {
        this.toggleIsActive();
        this.dispatchEvent(FanLetterItemButtonHeartEvent, {
          bubbles: true,
          detail: {
            fan_letter_id: this.fan_letter_id,
            store_id: this.store_id,
            is_like: this.getIsActive(),
          },
        });
      } else {
        return goLogin();
      }
    });
  }
}
